module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Bold-8e8a9bca4e5beba82649670f31dedc0b.woff";